import React, { useEffect } from "react";
import classnames from "classnames";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import {
	Card, CardBody, CardHeader, Container,
	Nav, NavItem, Row, Col,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import CompanyInfo from "./Company/CompanyInfo";
import UserInfo from "./UserInfo";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import checkPermission from "../../Components/Hooks/PermissionHook";
import Preloader from "../../Components/Common/Preloader";
import { ToastContainer } from "react-toastify";
import CompanyEditModal from "./Company/CompanyEditModal";
import { setBreadcrumb } from "../../slices/auth/menu/reducer";

/**
* Settings component representing the main settings page.
* This component displays a layout for various settings sections such as
* personal details, change password, company details, user list, and privacy policy.
* @component
*/
function Settings() {
	const dispatch = useDispatch();
	const location = useLocation();
	const path = location.pathname.replace("/settings/", "");
	document.title = "Settings | Adcropper";

	const selectStates = createSelector(state => state, state => ({
		company: state.MenuData.client,
		innerPreloaderState: state.Layout.innerPreloader,
		pageTitle: state.MenuData.pageTitle,
		title: state.MenuData.title,
		personalInfo: state.Settings.personalInfo
	}));
	const { company, innerPreloaderState, pageTitle, title, personalInfo } = useSelector(selectStates);

	return (
		<React.Fragment>
			<div className="page-content">
				<ToastContainer closeButton={false} />
				<Container fluid>
					<Row>
						<Col xxl={3} xl={4}>
							{personalInfo ?
								<UserInfo />
								: null}
							{company ?
								<CompanyInfo />
								: null}
						</Col>
						<Col xxl={9} xl={8}>
							<Card>
								<CardHeader>
									<Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
										<NavItem>
											<NavLink
												to="personal-details"
												className={"nav-link " + classnames({ active: path == "personal-details" })}
												type="button">
												<i className="fas fa-home"></i>
												Personal Details
											</NavLink>
										</NavItem>
										<NavItem>
											<NavLink
												to="change-password"
												className={"nav-link " + classnames({ active: path == "change-password" })}
												type="button">
												<i className="far fa-user"></i>
												Change Password
											</NavLink>
										</NavItem>
										{/* {checkPermission("companies", company._id, "companyDetailsView") ? */}
										<NavItem >
											<NavLink to="company-details"
												className={"nav-link " + classnames({ active: path === "company-details" })}
												type="button">
												<i className="far fa-envelope"></i>
												Company Details
											</NavLink>
										</NavItem>
										{/*  : null} */}
										{/* {checkPermission("companies", company._id, "userView") ? */}
										<NavItem>
											<NavLink to="user-list"
												className={"nav-link " + classnames({ active: path === "user-list" })}
												type="button">
												<i className="far fa-envelope"></i>
												User List
											</NavLink>
										</NavItem>
										{/* : null} */}
										{/* <NavItem>
											<NavLink to="privacy-policy"
												className={"nav-link " + classnames({ active: path === "privacy-policy" })}
												type="button">
												<i className="far fa-envelope"></i>
												Privacy Policy
											</NavLink>
										</NavItem> */}
									</Nav>
								</CardHeader>
								<CardBody>
									{innerPreloaderState ?
										<Preloader isComponentLoader={true} />
										:
										<Outlet />
									}
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
			<CompanyEditModal />
		</React.Fragment>
	);
}

export default Settings;